module.exports = __webpack_public_path__ + "img/icon-browser-page-account.c8a59515.svg";